import { Injectable } from '@angular/core';
import { Store, createSelector, select } from '@ngrx/store';
import { Observable, map } from 'rxjs';

import { DashboardItemEntity } from '../components/dashboard-list/dashboard-item.entity';
import { DashboardListEntity } from '../components/dashboard-list/dashboard-list.entity';
import { DashboardSliceKey, DashboardMainSliceState } from './dashboard.state';
import { DashboardRootState, featureSelector } from './feature.store';

const baseSelector = createSelector(
	featureSelector,
	(state) => state[DashboardSliceKey]
);

const listSelector = createSelector(baseSelector, (state) => state.list);

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const dashboardById = (id: number) =>
	createSelector(listSelector, (list) => list.elements.get(`${id}`));

@Injectable()
export class DashboardSelector {
	public constructor(private readonly store: Store<DashboardRootState>) {}

	private get state(): Observable<DashboardMainSliceState> {
		return this.store.pipe(select(baseSelector));
	}
	public getLoading$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('loading')));
	}

	public getSuccessDeleteDashboards$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('deleteSuccess')));
	}

	public getDashboardList$(): Observable<DashboardListEntity> {
		return this.store.pipe(select(listSelector));
	}

	public getSelectedDashboards$(
		selected: Array<string>
	): Observable<Array<DashboardItemEntity>> {
		return this.getDashboardList$().pipe(
			map((list) =>
				selected.reduce<Array<DashboardItemEntity>>((acc, curr) => {
					const maybe = list.elements.get(`${curr}`);
					if (maybe) {
						acc.push(maybe);
						return acc;
					}
					return acc;
				}, [])
			)
		);
	}
}
